import { RouteError } from '@/components/route-error'
import { createFileRoute } from '@tanstack/react-router'
import { RoutePending } from '@/components/route-pending'
import { AdjustmentsPage } from './_dashboard.inventory.adjustments'

export const Route = createFileRoute('/_dashboard/inventory/adjustments/$item')({
  pendingComponent: RoutePending,
  errorComponent: RouteError,
  component: AdjustmentsItemPage,
})

function AdjustmentsItemPage() {
  const { item } = Route.useParams()
  return <AdjustmentsPage selectedId={item} />
}
